import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  selectIsAuthenticated,
  selectAuthStatus,
  UserState,
  login,
} from "@onmo/auth";
import { PageRoutes } from "../constants/routes";
import { useAppSelector } from "../hooks";

const OnboardingLayout: React.FC = () => {
  const location = useLocation();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const state = useAppSelector(selectAuthStatus);
  const { theme } = useAppSelector((state) => state.theme);

  const at = (p: string) => location.pathname.startsWith(p);
  const hasOnboarded = localStorage.getItem("hasOnboarded") === "true";

  useEffect(() => {
    if (!hasOnboarded || theme.showFakeHomePage || isAuthenticated) return;
    const onLogin = async () => {
      await login();
    };
    onLogin();
  }, [theme.showFakeHomePage, hasOnboarded, isAuthenticated]);

  if (!hasOnboarded && !at(PageRoutes.Onboarding) && !isAuthenticated) {
    return <Navigate to={PageRoutes.Onboarding} replace />;
  }
  if (
    hasOnboarded &&
    !at(PageRoutes.Guest) &&
    state === UserState.NOT_AUTHENTICATED &&
    theme.showFakeHomePage
  ) {
    return <Navigate to={PageRoutes.Guest} replace />;
  }

  if (
    (hasOnboarded && isAuthenticated && at(PageRoutes.Guest)) ||
    (hasOnboarded && isAuthenticated && at(PageRoutes.Onboarding))
  ) {
    return <Navigate to={PageRoutes.Home} replace />;
  }

  return <Outlet />;
};

export default OnboardingLayout;
